<template>
	<div class="context-menu" :class="{arrow: topArrow, 'submenu-content': subMenu, 'white-theme': whiteTheme}"  :style="{ top: (top + 8) + 'px', left: left + 'px' , bottom: bottom + 'px'}">
		<slot />
	</div>
</template>

<script>
	import EventBus from '@/assets/js/eventBus.js'
	import CustomPopover from '@/components/CustomPopover'

	export default {
		name: 'contextMenu',
		props: {
			top: { type: Number },
			left: { type: Number },
			bottom: { type: Number },
			topArrow: Boolean,
			subMenu: Boolean,
			whiteTheme:{
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
			}
		},
		methods: {
			onOutsideClick(event){
				if(!this.$el.contains(event.target) && !this.$parent.$el.contains( event.target)) this.$emit('close')
			}
		},
		mounted () {
			setTimeout(() => {
				if (!this.$root.outsideClickHandler) {
				this.$root.outsideClickHandler = event => this.$root.$emit('window-click', event)
					window.addEventListener('click', this.$root.outsideClickHandler)
				}
				this.$root.$on('window-click', this.onOutsideClick)
			}, 100);
		},
		beforeDestroy () {
			this.$root.$off('window-click', this.onOutsideClick)
		}
	}
</script>

<style lang="less">
	.context-menu {
		position: fixed;
		transform: translateX(-50%);
		padding: 10px 0;
		color: #3D464A;
		// background: #fbfbfb;
		// background: #6E757A;
		background: #333A3E;
		box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.8);
		border-radius: 2px;
		z-index: 999;

		.menu-item {
			display: block;
			padding: 0 10px;
			font-size: 11px;
			font-weight: 500;
			white-space: nowrap;
			color: #f1f1f1 !important;
			&:hover {
				// background-color: #f1f1f1;
				background-color: rgb(152, 157, 160);
				color: #8F979C;
	
		}
				}
			.var{
				color: var(--flame) !important;
			}
			.syn{
				color: rgb(171, 223, 240) !important;
				// color: #42F5C7 !important;
			}
			.ai-syn{
				color: #b57bff !important;

				.loading{
					// text-align: right;
					color: #fff !important;
				}
			}
			.method{
				// color:#32A168 !important;
				color:lightgreen !important;
			}
		.submenu{
			position: relative;
				> span{
					&:after{
						content: "\203A";
						transform: scale(1.8);
						margin-left: 10px;
						right: 8px;
						float: right;
						// position: absolute; // maybe shouldnt be absolute.
					}
				}
			.custom-context-menu{
				position: absolute;
				bottom: -10px;
				left: 99%;
				padding: 10px 0;
				color: #3D464A;
				// background: #6E757A;
				background: #333A3E;
				box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.8);
				border-radius: 2px;
				z-index: 999;
			}
			.custom-context-menu-descending{
				position: absolute;
				top: -10px;
				left: 99%;
				padding: 10px 0;
				color: #3D464A;
				// background: #6E757A;
				background: #333A3E;
				box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.8);
				border-radius: 2px;
				z-index: 999;
			}			
		}
	}
	.white-theme{
		background: #fff;
		color: #3D464A;
	}
	.submenu-content{
		transform: translate(50%);

	}
	.context-menu.arrow{		
		&:before {
			content: "";
			border-left: 7px solid transparent;
			border-right: 7px solid transparent;
			border-bottom: 7px solid #333A3E;;
			position: absolute;
			display: block;
			z-index: 100;
			top: -7px;
			left: 40%;
		}
	}
</style>

